module.exports = __webpack_public_path__ + "img/cattunnel41.149cbeb3.jpg";